"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base Google Analytics event, including an event name to fire a GTM trigger
 *
 * @name BaseGoogleAnalyticsEvent
 * @param {Object} params
 * @param {string} gtmEventName - event name to fire a GTM custom event trigger
 * @param {string} category - GA event category
 * @param {string} action - GA event action
 * @param {string} label - GA event label
 * @param {number} value - GA event value
 */
var BaseGoogleAnalyticsEvent = function BaseGoogleAnalyticsEvent(_ref) {
    var gtmEventName = _ref.gtmEventName,
        category = _ref.category,
        action = _ref.action,
        label = _ref.label,
        value = _ref.value;

    _classCallCheck(this, BaseGoogleAnalyticsEvent);

    Object.assign(this, {
        event: gtmEventName,
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
    });
};

exports.default = BaseGoogleAnalyticsEvent;
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/events/BaseGoogleAnalyticsEvent.js
// module id = 334
// module chunks = 0